export default "__VITE_ASSET__a0e25810__"